var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{ref:"table",attrs:{"loadObj":{},"option":{},"colObj":{
      opId:"11",
      name:"角色授权权限明细",
      parentId:"ROLE_ID",
      parentName:"角色授权(按权限)",
      parentPath:"/system/roleAuthorization",
      dataClass:2,
      addClick: _vm.addClick,
    }}}),_c('m-selectorcc',{attrs:{"visible":_vm.select,"select":{
    searchslotType: "",
    searchslottitle: "请选择角色",
    multiple: true,
    searchslotId: 105,
    searchslotkey: { ID: "ID" },
    filterWhere:_vm.$route.query.ROLE_ID,//过滤
    colname:"aqxsqxzqx"
  }},on:{"update:visible":function($event){_vm.select=$event},"listenEvent":_vm.fn}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }